export function getCanonicalThreadPath(
  orgSlug: string,
  routeId: string
): string {
  return `/${encodeURIComponent(orgSlug)}/threads/${encodeURIComponent(routeId)}`;
}

export function getOrgDesignPath(orgSlug: string): string {
  return `/${encodeURIComponent(orgSlug)}/design`;
}

export function getOrgSettingsPurchasePath(orgSlug: string): string {
  return `/${encodeURIComponent(orgSlug)}/settings/purchase`;
}

export function shouldReplaceCanonicalThreadUrl(
  currentRouteRef: string,
  canonicalRouteId: string
): boolean {
  return canonicalRouteId.length > 0 && canonicalRouteId !== currentRouteRef;
}

export function getCanonicalThreadHref(
  pathname: string,
  search: string,
  hash: string
): string {
  return `${pathname}${search}${hash}`;
}

export function replaceCanonicalThreadUrl(pathname: string): void {
  if (typeof window === 'undefined') return;
  const nextHref = getCanonicalThreadHref(
    pathname,
    window.location.search,
    window.location.hash
  );
  const currentHref = getCanonicalThreadHref(
    window.location.pathname,
    window.location.search,
    window.location.hash
  );
  if (currentHref === nextHref) return;
  // history.replaceState updates the address bar without informing the Next
  // App Router tree. `useParams().id` and the layout's server `params.id`
  // therefore keep the alias until a real navigation. That is the intended
  // tradeoff: a router.replace would remount `loading.tsx` over the message
  // column during canonicalization.
  window.history.replaceState(window.history.state, '', nextHref);
}

/**
 * Where a conversation owned by its own surface (`managedRoute`, e.g. Your
 * IMAI) opens instead of the thread page: that surface in the conversation's
 * own workspace, whatever workspace the URL named. Null when the thread is
 * not managed, or while the viewer's workspace list is still loading. The
 * URL's workspace is used only when the list lacks the owning one.
 */
export function managedThreadPath(
  thread: { managedRoute?: string; organizationId: string } | null | undefined,
  workspaces: readonly { _id: string; slug: string }[] | undefined,
  urlOrgSlug: string
): string | null {
  if (!thread?.managedRoute || !workspaces) return null;
  const slug =
    workspaces.find((workspace) => workspace._id === thread.organizationId)
      ?.slug ?? urlOrgSlug;
  return `/${encodeURIComponent(slug)}/${thread.managedRoute}`;
}
